import api from './client';
import ApiError from './error';

const TermService = {
  async searchTerms() {
    try {
      const client = await api.getClient();
      return client.termIndex();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default TermService;
